module.exports = __webpack_public_path__ + "img/header_form_mobile_v2.e33ba74d.png";